import config from '@app/config'

export const getDefaultUrlBase = (): string => {
  if (typeof window !== 'undefined') {
    return window.location.origin
  }

  return 'https://www.properstar.com'
}

export const buildFlagPath = (
  countryCode: string,
  density: '1x' | '2x'
): string | undefined => {
  const normalizedCountryCode = countryCode.trim().toLowerCase()

  if (!normalizedCountryCode) {
    return undefined
  }

  const base =
    config.variables.properstarLink ||
    config.identity.dashboardUrl ||
    config.identity.website ||
    getDefaultUrlBase()

  try {
    return new URL(
      `/assets/flags/${density}/${normalizedCountryCode}.png`,
      base
    ).toString()
  } catch {
    return undefined
  }
}

export const resolveLocalizedLabel = (
  code: string,
  type: 'language' | 'region',
  locale: string
): string => {
  if (!code.trim()) {
    return ''
  }

  try {
    const displayNames = new Intl.DisplayNames([locale || 'en'], { type })

    return displayNames.of(code) || code
  } catch {
    return code
  }
}

export const getProfileLabel = (username: string, email: string): string => {
  const firstName = username.trim().split(' ')[0]

  if (firstName) {
    return firstName
  }

  if (username) {
    return username
  }

  return email
}
